import { render, staticRenderFns } from "./BazarObligacion.vue?vue&type=template&id=2d6f9967&"
import script from "./BazarObligacion.vue?vue&type=script&lang=js&"
export * from "./BazarObligacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports